import {useNavigate} from "react-router-dom";
import {ReactComponent as CardLab} from "../../../assets/images/Card_Laboratorio.svg";
import {eventTag} from "../../../services/utils";
import './index.scss';

const eventLabGA = {
	name: "comparison_laboratory",
	category: "comparison_laboratory",
	action: "click",
}

const ComparisonLabAccess = () => {
	const navigate = useNavigate();
	return (
		<div
			className="comparison-lab-container no-mobile animate__animated animate__fadeIn"
			style={{ animationDelay: "0ms" }}
		>
			<CardLab onClick={() => {
				navigate("/laboratorio-de-comparacoes")
				eventTag(eventLabGA?.name, eventLabGA?.category, eventLabGA?.action, "Banner laboratório de comparação")
			}} />
		</div>
	)
}

export default ComparisonLabAccess;
